$(document).ready(function($) {
    $('.industry-blocks-wrapper ol li a').bind('click', function(e){
        //remove the active class from other list items
        $('.industry-blocks-wrapper ol li').removeClass('active');
        $('.industry-blocks-wrapper ul li').removeClass('active');
        //add active class to the clicked item
        $(this).parent().addClass('active');
        var activeIndex = $(this).parent().index();
        $('.industry-blocks-wrapper ul li').eq(activeIndex).addClass('active');
        //scroll to the top of the featured blocks
        $(this).parents('.mobile-wrapper').removeClass('active');
        $(this).parents('.mobile-wrapper').find('> a').removeClass().addClass($(this).attr('class')).html($(this).html());
        $('html,body').animate({
            scrollTop: $('.industry-blocks-wrapper').offset().top - 100
        }, 500);
        e.preventDefault();
    });

    $('.industry-blocks-wrapper .mobile-wrapper > a').on('click', function(e){
        $(this).parent().toggleClass('active');
        e.preventDefault();
    });
});